export default __webpack_public_path__ + "static/media/pod.9626376b.svg";